// // import { useState } from "react";
// // import { Link } from "react-router-dom";
// // import { collection, addDoc } from "firebase/firestore";

// // import { db } from "../../firebase";
// // import Footer from "../../components/Footer";
// // import SubscriptionPlansConfig from "../../config/subscriptionPlansConfig";
// // import { useAuth } from "../../context/AuthContext";

// // import { toast, ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import axios from "axios";

// // function Subsplan() {
// //   const { globalUser } = useAuth();

// //   const [selectedStudentPlan, setSelectedStudentPlan] = useState(0); // 0 = 6 months, 1 = yearly
// //   const [showEnquiryModal, setShowEnquiryModal] = useState(false);
// //   const [paymentLoading, setPaymentLoading] = useState(false);

// //   const [enquiryForm, setEnquiryForm] = useState({
// //     name: "",
// //     representingFirm: "No",
// //     firmName: "",
// //     email: "",
// //     contactNo: "",
// //     requirements: "",
// //   });

// //   /* ---------------- ENQUIRY HANDLERS ---------------- */

// //   const handleEnquiryChange = (e) => {
// //     const { name, value } = e.target;
// //     setEnquiryForm((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const handleEnquirySubmit = async (e) => {
// //     e.preventDefault();

// //     if (!enquiryForm.name || !enquiryForm.email || !enquiryForm.contactNo) {
// //       toast.error("Please fill all required fields");
// //       return;
// //     }

// //     try {
// //       await addDoc(collection(db, "enterpriseEnquiries"), {
// //         ...enquiryForm,
// //         userId: globalUser?.uid || "anonymous",
// //         timestamp: new Date(),
// //       });

// //       await Promise.all([
// //         axios.post(
// //           "https://jurident-feedback-backend-596718606544.us-central1.run.app/sendQuery",
// //           {
// //             name: enquiryForm.name,
// //             email: enquiryForm.email,
// //             phoneNumber: enquiryForm.contactNo,
// //             query: enquiryForm.requirements || "Enterprise subscription enquiry",
// //           }
// //         ),
// //         axios.post(
// //           "https://jurident-feedback-backend-596718606544.us-central1.run.app/send-enquiry-thank-you",
// //           {
// //             name: enquiryForm.name,
// //             email: enquiryForm.email,
// //           }
// //         ),
// //       ]);

// //       toast.success("Enquiry submitted successfully");
// //       setShowEnquiryModal(false);
// //       setEnquiryForm({
// //         name: "",
// //         representingFirm: "No",
// //         firmName: "",
// //         email: "",
// //         contactNo: "",
// //         requirements: "",
// //       });
// //     } catch (err) {
// //       console.error(err);
// //       toast.error("Failed to submit enquiry");
// //     }
// //   };

// //   const openAppUpgrade = () => {
// //     window.open(
// //       "https://play.google.com/store/apps/details?id=com.jurident.valsco&hl=en_IN",
// //       "_blank"
// //     );
// //   };

// //   return (
// //     <>
// //       <div className="min-h-screen bg-white pt-[100px] pb-20">
// //         <div className="max-w-6xl mx-auto px-4">

// //           {/* TITLE */}
// //           <h1 className="text-4xl font-bold text-center text-yellow-500 mb-12">
// //             Subscription Plans
// //           </h1>

// //           {/* ================= LAWYERS ================= */}
// //           <div className="bg-[#1E1E45] rounded-2xl p-8 border-2 border-white mb-16">
// //             <h2 className="text-3xl font-bold text-yellow-500 text-center mb-12">
// //               Lawyers
// //             </h2>

// //             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
// //               {/* BASIC */}
// //               <PlanCard
// //                 plan={SubscriptionPlansConfig.LAWYER_BASIC}
// //                 buttonText="Upgrade from App"
// //                 onClick={openAppUpgrade}
// //               />

// //               {/* PREMIUM */}
// //               <PlanCard
// //                 plan={SubscriptionPlansConfig.LAWYER_PREMIUM}
// //                 highlight
// //                 buttonText="Upgrade from App"
// //                 onClick={openAppUpgrade}
// //               />

// //               {/* ENTERPRISE */}
// //               <PlanCard
// //                 plan={SubscriptionPlansConfig.LAWYER_ENTERPRISE}
// //                 buttonText="Inquire"
// //                 onClick={() => setShowEnquiryModal(true)}
// //               />
// //             </div>
// //           </div>

// //           {/* ================= LAW STUDENT ================= */}
// //           <div className="bg-[#1E1E45] rounded-2xl p-8 border-2 border-white">
// //             <h2 className="text-3xl font-bold text-green-400 text-center mb-8">
// //               Law Students
// //             </h2>

// //             <div className="flex justify-center gap-4 mb-6">
// //               <button
// //                 onClick={() => setSelectedStudentPlan(0)}
// //                 className={`px-6 py-2 rounded-full ${
// //                   selectedStudentPlan === 0
// //                     ? "bg-yellow-500 text-black"
// //                     : "bg-black text-white"
// //                 }`}
// //               >
// //                 6 Months
// //               </button>
// //               <button
// //                 onClick={() => setSelectedStudentPlan(1)}
// //                 className={`px-6 py-2 rounded-full ${
// //                   selectedStudentPlan === 1
// //                     ? "bg-yellow-500 text-black"
// //                     : "bg-black text-white"
// //                 }`}
// //               >
// //                 Yearly
// //               </button>
// //             </div>

// //             <PlanCard
// //               plan={
// //                 selectedStudentPlan === 0
// //                   ? SubscriptionPlansConfig.LAW_STUDENT_SIX_MONTHS
// //                   : SubscriptionPlansConfig.LAW_STUDENT_ONE_YEAR
// //               }
// //               buttonText="Upgrade from App"
// //               onClick={openAppUpgrade}
// //             />
// //           </div>
// //         </div>
// //         <div className="max-w-5xl mx-auto px-6 md:px-10 mt-20">
// //         <div className="flex items-start gap-3 text-gray-600 text-base md:text-lg">
// //           <span className="text-[#D0A95C] font-semibold">*</span>
// //           <p className="leading-relaxed">
// //             Pricing is flexible and tailored to your specific requirements.
// //             Costs may vary depending on customization and selected features.
// //           </p>
// //         </div>
// //       </div>
// //       </div>

// //       {/* ================= ENQUIRY MODAL ================= */}
// //       {showEnquiryModal && (
// //         <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999] p-4">
// //           <div className="bg-[#050125] rounded-3xl border-2 border-white max-w-md w-full">
// //             <div className="p-6">
// //               <h2 className="text-xl text-white font-bold mb-4 text-center">
// //                 Enterprise Enquiry
// //               </h2>

// //               <form onSubmit={handleEnquirySubmit} className="space-y-4">
// //                 {["name", "email", "contactNo"].map((field) => (
// //                   <input
// //                     key={field}
// //                     name={field}
// //                     value={enquiryForm[field]}
// //                     onChange={handleEnquiryChange}
// //                     placeholder={field}
// //                     className="w-full bg-transparent border-2 border-white px-3 py-2 rounded-xl text-white"
// //                     required
// //                   />
// //                 ))}

// //                 <textarea
// //                   name="requirements"
// //                   value={enquiryForm.requirements}
// //                   onChange={handleEnquiryChange}
// //                   placeholder="Your requirements"
// //                   className="w-full bg-transparent border-2 border-white px-3 py-2 rounded-xl text-white"
// //                 />

// //                 <button className="w-full border-2 border-white py-2 rounded-xl text-white">
// //                   Submit Enquiry
// //                 </button>
// //               </form>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <Footer />
// //     </>
// //   );
// // }

// // /* ================= PLAN CARD COMPONENT ================= */

// // function PlanCard({ plan, buttonText, onClick, highlight }) {
// //   return (
// //     <div
// //       className={`bg-[#060125] rounded-2xl p-6 border-2 ${
// //         highlight ? "border-yellow-500 scale-105" : "border-white"
// //       } flex flex-col`}
// //     >
// //       <h3 className="text-2xl font-bold text-yellow-500 text-center mb-4">
// //         {plan.name}
// //       </h3>

// //       <div className="text-3xl font-bold text-white text-center mb-6">
// //         {plan.priceDisplay}
// //         {plan.duration && (
// //           <span className="text-lg text-gray-400">{plan.duration}</span>
// //         )}
// //       </div>

// //       <div className="space-y-3 flex-grow mb-6">
// //         {plan.features.map((f, i) => (
// //           <div key={i} className="flex items-center">
// //             <span className="text-yellow-500 mr-2">✔</span>
// //             <span className="text-white">{f}</span>
// //           </div>
// //         ))}
// //       </div>

// //       <button
// //         onClick={onClick}
// //         className="w-full bg-gray-700 hover:bg-gray-600 text-white py-3 rounded-lg font-semibold"
// //       >
// //         {buttonText}
// //       </button>
// //     </div>
// //   );
// // }

// // export default Subsplan;





















// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { collection, addDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import Footer from "../../components/Footer";
// import SubscriptionPlansConfig from "../../config/subscriptionPlansConfig";
// import { useAuth } from "../../context/AuthContext";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";

// function Subsplan() {
//   const { globalUser } = useAuth();

//   const [selectedStudentPlan, setSelectedStudentPlan] = useState(0);
//   const [showEnquiryModal, setShowEnquiryModal] = useState(false);

//   const [enquiryForm, setEnquiryForm] = useState({
//     name: "",
//     representingFirm: "No",
//     firmName: "",
//     email: "",
//     contactNo: "",
//     requirements: "",
//   });

//   const handleEnquiryChange = (e) => {
//     const { name, value } = e.target;
//     setEnquiryForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleEnquirySubmit = async (e) => {
//     e.preventDefault();

//     if (!enquiryForm.name || !enquiryForm.email || !enquiryForm.contactNo) {
//       toast.error("Please fill all required fields");
//       return;
//     }

//     try {
//       await addDoc(collection(db, "enterpriseEnquiries"), {
//         ...enquiryForm,
//         userId: globalUser?.uid || "anonymous",
//         timestamp: new Date(),
//       });

//       await Promise.all([
//         axios.post(
//           "https://jurident-feedback-backend-596718606544.us-central1.run.app/sendQuery",
//           {
//             name: enquiryForm.name,
//             email: enquiryForm.email,
//             phoneNumber: enquiryForm.contactNo,
//             query: enquiryForm.requirements || "Enterprise subscription enquiry",
//           }
//         ),
//         axios.post(
//           "https://jurident-feedback-backend-596718606544.us-central1.run.app/send-enquiry-thank-you",
//           {
//             name: enquiryForm.name,
//             email: enquiryForm.email,
//           }
//         ),
//       ]);

//       toast.success("Enquiry submitted successfully");
//       setShowEnquiryModal(false);
//       setEnquiryForm({
//         name: "",
//         representingFirm: "No",
//         firmName: "",
//         email: "",
//         contactNo: "",
//         requirements: "",
//       });
//     } catch {
//       toast.error("Failed to submit enquiry");
//     }
//   };

//   const openAppUpgrade = () => {
//     window.open(
//       "https://play.google.com/store/apps/details?id=com.jurident.valsco&hl=en_IN",
//       "_blank"
//     );
//   };

//   return (
//     <>
//       <ToastContainer />

//       <section className="min-h-screen bg-gradient-to-b from-[#050125] to-black pt-28 pb-32">
//         <div className="max-w-7xl mx-auto px-6">

//           {/* PAGE TITLE */}
//           <h1 className="text-center text-4xl md:text-5xl font-extrabold text-[#D0A95C] mb-6">
//             Subscription Plans
//           </h1>
//           <p className="text-center text-gray-400 mb-20 max-w-2xl mx-auto">
//             Choose a plan that fits your legal workflow — scale as you grow.
//           </p>

//           {/* LAWYERS */}
//           <Section title="For Lawyers">
//             <div className="grid md:grid-cols-3 gap-8">
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_BASIC}
//                 buttonText="Upgrade from App"
//                 onClick={openAppUpgrade}
//               />
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_PREMIUM}
//                 highlight
//                 buttonText="Most Popular"
//                 onClick={openAppUpgrade}
//               />
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_ENTERPRISE}
//                 buttonText="Enterprise Enquiry"
//                 onClick={() => setShowEnquiryModal(true)}
//               />
//             </div>
//           </Section>

//           {/* STUDENTS */}
//           <Section title="For Law Students">
//             <div className="flex justify-center gap-4 mb-10">
//               {["6 Months", "Yearly"].map((label, idx) => (
//                 <button
//                   key={idx}
//                   onClick={() => setSelectedStudentPlan(idx)}
//                   className={`px-6 py-2 rounded-full font-semibold transition ${
//                     selectedStudentPlan === idx
//                       ? "bg-[#D0A95C] text-black"
//                       : "bg-white/10 text-white hover:bg-white/20"
//                   }`}
//                 >
//                   {label}
//                 </button>
//               ))}
//             </div>

//             <div className="flex justify-center">
//               <PlanCard
//                 plan={
//                   selectedStudentPlan === 0
//                     ? SubscriptionPlansConfig.LAW_STUDENT_SIX_MONTHS
//                     : SubscriptionPlansConfig.LAW_STUDENT_ONE_YEAR
//                 }
//                 buttonText="Upgrade from App"
//                 onClick={openAppUpgrade}
//               />
//             </div>
//           </Section>

//           {/* NOTE */}
//           <div className="mt-20 max-w-4xl mx-auto text-gray-400 flex gap-3">
//             <span className="text-[#D0A95C]">*</span>
//           Pricing is flexible and tailored to your specific requirements. Costs may vary depending on customization and selected features.
//           </div>
//         </div>
//       </section>

//       {/* ENTERPRISE MODAL */}
//       {showEnquiryModal && (
//         <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[9999]">
//           <div className="bg-[#050125] rounded-3xl border border-white/20 p-8 w-full max-w-md">
//             <h2 className="text-xl text-[#D0A95C] font-bold mb-6 text-center">
//               Enterprise Enquiry
//             </h2>

//             <form onSubmit={handleEnquirySubmit} className="space-y-4">
//               {["name", "email", "contactNo"].map((field) => (
//                 <input
//                   key={field}
//                   name={field}
//                   value={enquiryForm[field]}
//                   onChange={handleEnquiryChange}
//                   placeholder={field}
//                   className="w-full bg-transparent border border-white/30 px-4 py-3 rounded-xl text-white"
//                   required
//                 />
//               ))}

//               <textarea
//                 name="requirements"
//                 value={enquiryForm.requirements}
//                 onChange={handleEnquiryChange}
//                 placeholder="Your requirements"
//                 className="w-full bg-transparent border border-white/30 px-4 py-3 rounded-xl text-white"
//               />

//               <button className="w-full bg-[#D0A95C] text-black py-3 rounded-xl font-semibold hover:scale-105 transition">
//                 Submit Enquiry
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// }

// /* ---------- SECTION ---------- */
// const Section = ({ title, children }) => (
//   <div className="mb-28">
//     <h2 className="text-3xl font-bold text-white text-center mb-12">
//       {title}
//     </h2>
//     {children}
//   </div>
// );

// /* ---------- PLAN CARD ---------- */
// function PlanCard({ plan, buttonText, onClick, highlight }) {
//   return (
//     <div
//       className={`relative bg-white/5 backdrop-blur-xl border rounded-3xl p-8 flex flex-col
//       transition-all hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.4)]
//       ${highlight ? "border-[#D0A95C] scale-105" : "border-white/10"}`}
//     >
//       {highlight && (
//         <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D0A95C] text-black px-4 py-1 text-xs font-bold rounded-full">
//           POPULAR
//         </span>
//       )}

//       <h3 className="text-2xl font-bold text-[#D0A95C] text-center mb-4">
//         {plan.name}
//       </h3>

//       <div className="text-3xl font-bold text-white text-center mb-6">
//         {plan.priceDisplay}
//         {plan.duration && (
//           <span className="text-lg text-gray-400">{plan.duration}</span>
//         )}
//       </div>

//       <div className="space-y-3 mb-8 flex-grow">
//         {plan.features.map((f, i) => (
//           <div key={i} className="flex gap-2 text-gray-200">
//             <span className="text-[#D0A95C]">✔</span>
//             {f}
//           </div>
//         ))}
//       </div>

//       <button
//         onClick={onClick}
//         className="mt-auto w-full py-3 rounded-xl font-semibold
//         bg-white/10 hover:bg-[#D0A95C] hover:text-black transition"
//       >
//         {buttonText}
//       </button>
//     </div>
//   );
// }

// export default Subsplan;
























// import { useState } from "react";
// import { collection, addDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import Footer from "../../components/Footer";
// import SubscriptionPlansConfig from "../../config/subscriptionPlansConfig";
// import { useAuth } from "../../context/AuthContext";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";

// function Subsplan() {
//   const { globalUser } = useAuth();

//   const [activeTab, setActiveTab] = useState("lawyer"); // lawyer | student
//   const [selectedStudentPlan, setSelectedStudentPlan] = useState(0);
//   const [showEnquiryModal, setShowEnquiryModal] = useState(false);

//   const [enquiryForm, setEnquiryForm] = useState({
//     name: "",
//     representingFirm: "No",
//     firmName: "",
//     email: "",
//     contactNo: "",
//     requirements: "",
//   });

//   const handleEnquiryChange = (e) => {
//     const { name, value } = e.target;
//     setEnquiryForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleEnquirySubmit = async (e) => {
//     e.preventDefault();

//     if (!enquiryForm.name || !enquiryForm.email || !enquiryForm.contactNo) {
//       toast.error("Please fill all required fields");
//       return;
//     }

//     try {
//       await addDoc(collection(db, "enterpriseEnquiries"), {
//         ...enquiryForm,
//         userId: globalUser?.uid || "anonymous",
//         timestamp: new Date(),
//       });

//       await Promise.all([
//         axios.post(
//           "https://jurident-feedback-backend-596718606544.us-central1.run.app/sendQuery",
//           {
//             name: enquiryForm.name,
//             email: enquiryForm.email,
//             phoneNumber: enquiryForm.contactNo,
//             query: enquiryForm.requirements || "Enterprise subscription enquiry",
//           }
//         ),
//         axios.post(
//           "https://jurident-feedback-backend-596718606544.us-central1.run.app/send-enquiry-thank-you",
//           {
//             name: enquiryForm.name,
//             email: enquiryForm.email,
//           }
//         ),
//       ]);

//       toast.success("Enquiry submitted successfully");
//       setShowEnquiryModal(false);
//       setEnquiryForm({
//         name: "",
//         representingFirm: "No",
//         firmName: "",
//         email: "",
//         contactNo: "",
//         requirements: "",
//       });
//     } catch {
//       toast.error("Failed to submit enquiry");
//     }
//   };

//   const openAppUpgrade = () => {
//     window.open(
//       "https://play.google.com/store/apps/details?id=com.jurident.valsco&hl=en_IN",
//       "_blank"
//     );
//   };

//   return (
//     <>
//       <ToastContainer />

//       <section className="min-h-screen bg-[#f9fafb] pt-28 pb-32">
//         <div className="max-w-7xl mx-auto px-6">

//           {/* TITLE */}
//           <h1 className="text-center text-4xl md:text-5xl font-extrabold text-[#1E1E45] mb-4">
//             Subscription Plans
//           </h1>
//           <p className="text-center text-gray-600 mb-14 max-w-2xl mx-auto">
//             Simple, transparent pricing designed for legal professionals and students.
//           </p>

//           {/* TOGGLE */}
//           <div className="flex justify-center mb-16">
//             <div className="bg-white rounded-full shadow p-1 flex gap-1">
//               <ToggleButton
//                 active={activeTab === "lawyer"}
//                 onClick={() => setActiveTab("lawyer")}
//                 label="For Lawyers"
//               />
//               <ToggleButton
//                 active={activeTab === "student"}
//                 onClick={() => setActiveTab("student")}
//                 label="For Students"
//               />
//             </div>
//           </div>

//           {/* LAWYERS */}
//           {activeTab === "lawyer" && (
//             <div className="grid md:grid-cols-3 gap-8">
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_BASIC}
//                 buttonText="Upgrade from App"
//                 onClick={openAppUpgrade}
//               />
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_PREMIUM}
//                 highlight
//                 buttonText="Most Popular"
//                 onClick={openAppUpgrade}
//               />
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_ENTERPRISE}
//                 buttonText="Enterprise Enquiry"
//                 onClick={() => setShowEnquiryModal(true)}
//               />
//             </div>
//           )}

//           {/* STUDENTS */}
//           {activeTab === "student" && (
//             <>
//               <div className="flex justify-center gap-4 mb-10">
//                 {["6 Months", "Yearly"].map((label, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setSelectedStudentPlan(idx)}
//                     className={`px-6 py-2 rounded-full font-semibold transition ${
//                       selectedStudentPlan === idx
//                         ? "bg-[#D0A95C] text-black"
//                         : "bg-white text-gray-700 border hover:bg-gray-50"
//                     }`}
//                   >
//                     {label}
//                   </button>
//                 ))}
//               </div>

//               <div className="flex justify-center">
//                 <PlanCard
//                   plan={
//                     selectedStudentPlan === 0
//                       ? SubscriptionPlansConfig.LAW_STUDENT_SIX_MONTHS
//                       : SubscriptionPlansConfig.LAW_STUDENT_ONE_YEAR
//                   }
//                   buttonText="Upgrade from App"
//                   onClick={openAppUpgrade}
//                 />
//               </div>
//             </>
//           )}

//           {/* NOTE */}
//           <div className="mt-20 max-w-4xl mx-auto flex gap-2 text-gray-600">
//             <span className="text-[#D0A95C] font-bold">*</span>
//             Pricing is flexible and tailored to your requirements.
//           </div>
//         </div>
//       </section>

//       {/* ENQUIRY MODAL */}
//       {showEnquiryModal && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
//           <div className="bg-white rounded-3xl shadow-xl p-8 w-full max-w-md">
//             <h2 className="text-xl font-bold text-[#1E1E45] mb-6 text-center">
//               Enterprise Enquiry
//             </h2>

//             <form onSubmit={handleEnquirySubmit} className="space-y-4">
//               {["name", "email", "contactNo"].map((field) => (
//                 <input
//                   key={field}
//                   name={field}
//                   value={enquiryForm[field]}
//                   onChange={handleEnquiryChange}
//                   placeholder={field}
//                   className="w-full border px-4 py-3 rounded-xl"
//                   required
//                 />
//               ))}

//               <textarea
//                 name="requirements"
//                 value={enquiryForm.requirements}
//                 onChange={handleEnquiryChange}
//                 placeholder="Your requirements"
//                 className="w-full border px-4 py-3 rounded-xl"
//               />

//               <button className="w-full bg-[#D0A95C] text-black py-3 rounded-xl font-semibold hover:scale-105 transition">
//                 Submit Enquiry
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// }

// /* ---------- TOGGLE BUTTON ---------- */
// const ToggleButton = ({ active, onClick, label }) => (
//   <button
//     onClick={onClick}
//     className={`px-6 py-2 rounded-full font-semibold transition ${
//       active
//         ? "bg-[#1E1E45] text-white"
//         : "text-gray-600 hover:bg-gray-100"
//     }`}
//   >
//     {label}
//   </button>
// );

// /* ---------- PLAN CARD ---------- */
// function PlanCard({ plan, buttonText, onClick, highlight }) {
//   return (
//     <div
//       className={`bg-white border rounded-3xl p-8 flex flex-col
//       shadow-sm hover:shadow-xl transition-all hover:-translate-y-2
//       ${highlight ? "border-[#D0A95C] scale-105" : ""}`}
//     >
//       {highlight && (
//         <span className="self-center mb-4 bg-[#D0A95C] text-black px-4 py-1 text-xs font-bold rounded-full">
//           POPULAR
//         </span>
//       )}

//       <h3 className="text-2xl font-bold text-[#1E1E45] text-center mb-4">
//         {plan.name}
//       </h3>

//       <div className="text-3xl font-bold text-center mb-6">
//         {plan.priceDisplay}
//         {plan.duration && (
//           <span className="text-lg text-gray-500">{plan.duration}</span>
//         )}
//       </div>

//       <div className="space-y-3 mb-8 flex-grow">
//         {plan.features.map((f, i) => (
//           <div key={i} className="flex gap-2 text-gray-700">
//             <span className="text-[#D0A95C]">✔</span>
//             {f}
//           </div>
//         ))}
//       </div>

//       <button
//         onClick={onClick}
//         className="mt-auto w-full py-3 rounded-xl font-semibold
//         bg-[#1E1E45] text-white hover:bg-[#D0A95C] hover:text-black transition"
//       >
//         {buttonText}
//       </button>
//     </div>
//   );
// }

// export default Subsplan;














// //full final code

// import { useState } from "react";
// import { collection, addDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import Footer from "../../components/Footer";
// import SubscriptionPlansConfig from "../../config/subscriptionPlansConfig";
// import { useAuth } from "../../context/AuthContext";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";

// function Subsplan() {
//   const { globalUser } = useAuth();

//   const [activeTab, setActiveTab] = useState("lawyer");
//   const [selectedStudentPlan, setSelectedStudentPlan] = useState(0);
//   const [showEnquiryModal, setShowEnquiryModal] = useState(false);

//   const [enquiryForm, setEnquiryForm] = useState({
//     name: "",
//     representingFirm: "No",
//     firmName: "",
//     email: "",
//     contactNo: "",
//     requirements: "",
//   });

//   const handleEnquiryChange = (e) => {
//     const { name, value } = e.target;
//     setEnquiryForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleEnquirySubmit = async (e) => {
//     e.preventDefault();

//     if (!enquiryForm.name || !enquiryForm.email || !enquiryForm.contactNo) {
//       toast.error("Please fill all required fields");
//       return;
//     }

//     try {
//       await addDoc(collection(db, "enterpriseEnquiries"), {
//         ...enquiryForm,
//         userId: globalUser?.uid || "anonymous",
//         timestamp: new Date(),
//       });

//       await Promise.all([
//         axios.post(
//           "https://jurident-feedback-backend-596718606544.us-central1.run.app/sendQuery",
//           {
//             name: enquiryForm.name,
//             email: enquiryForm.email,
//             phoneNumber: enquiryForm.contactNo,
//             query: enquiryForm.requirements || "Enterprise subscription enquiry",
//           }
//         ),
//         axios.post(
//           "https://jurident-feedback-backend-596718606544.us-central1.run.app/send-enquiry-thank-you",
//           {
//             name: enquiryForm.name,
//             email: enquiryForm.email,
//           }
//         ),
//       ]);

//       toast.success("Enquiry submitted successfully");
//       setShowEnquiryModal(false);
//       setEnquiryForm({
//         name: "",
//         representingFirm: "No",
//         firmName: "",
//         email: "",
//         contactNo: "",
//         requirements: "",
//       });
//     } catch {
//       toast.error("Failed to submit enquiry");
//     }
//   };

//   const openAppUpgrade = () => {
//     window.open(
//       "https://play.google.com/store/apps/details?id=com.jurident.valsco&hl=en_IN",
//       "_blank"
//     );
//   };

//   return (
//     <>
//       <ToastContainer />

//       {/* PAGE */}
//       <section className="min-h-screen bg-gradient-to-b from-[#fdfcf9] to-[#f4f6fb] pt-28 pb-32">
//         <div className="max-w-7xl mx-auto px-6">

//           {/* TITLE */}
//           <h1 className="text-center text-4xl md:text-5xl font-extrabold text-[#1E1E45] mb-4">
//             Subscription Plans
//           </h1>
//           <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
//             Flexible, transparent pricing designed for modern legal workflows.
//           </p>

//           {/* TOGGLE */}
//           <div className="flex justify-center mb-20">
//             <div className="relative bg-white rounded-full shadow-md p-1 flex">
//               <ToggleButton
//                 active={activeTab === "lawyer"}
//                 onClick={() => setActiveTab("lawyer")}
//                 label="Lawyers/ Law Firms"
//               />
//               <ToggleButton
//                 active={activeTab === "student"}
//                 onClick={() => setActiveTab("student")}
//                 label="Students"
//               />
//             </div>
//           </div>

//           {/* LAWYERS */}
//           {activeTab === "lawyer" && (
//             <div className="flex justify-center gap-10 flex-wrap">
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_BASIC}
//                 buttonText="Upgrade from App"
//                 onClick={openAppUpgrade}
//               />
//               <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_ENTERPRISE}
//                 highlight
//                 buttonText="Enterprise Enquiry"
//                 onClick={openAppUpgrade}
//               />
//               {/* <PlanCard
//                 plan={SubscriptionPlansConfig.LAWYER_ENTERPRISE}
//                 buttonText="Enterprise Enquiry"
//                 onClick={() => setShowEnquiryModal(true)}
//               /> */}
//             </div>
//           )}

//           {/* STUDENTS */}
//           {activeTab === "student" && (
//             <>
//               <div className="flex justify-center gap-4 mb-12">
//                 {["6 Months", "Yearly"].map((label, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setSelectedStudentPlan(idx)}
//                     className={`px-6 py-2 rounded-full font-semibold transition-all ${
//                       selectedStudentPlan === idx
//                         ? "bg-[#D0A95C] text-black shadow-md"
//                         : "bg-white text-gray-700 border hover:bg-gray-50"
//                     }`}
//                   >
//                     {label}
//                   </button>
//                 ))}
//               </div>

//               <div className="flex justify-center">
//                 <PlanCard
//                   plan={
//                     selectedStudentPlan === 0
//                       ? SubscriptionPlansConfig.LAW_STUDENT_SIX_MONTHS
//                       : SubscriptionPlansConfig.LAW_STUDENT_ONE_YEAR
//                   }
//                   buttonText="Upgrade from App"
//                   onClick={openAppUpgrade}
//                 />
//               </div>
//             </>
//           )}

//           {/* NOTE */}
//           <div className="mt-24 max-w-4xl mx-auto flex gap-2 text-gray-600 text-sm">
//             <span className="text-[#D0A95C] font-bold">*</span>
//             Pricing is flexible and may vary based on customization and selected features.
//           </div>
//         </div>
//       </section>

//       {/* MODAL */}
//       {showEnquiryModal && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">
//           <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md">
//             <h2 className="text-xl font-bold text-[#1E1E45] mb-6 text-center">
//               Enterprise Enquiry
//             </h2>

//             <form onSubmit={handleEnquirySubmit} className="space-y-4">
//               {["name", "email", "contactNo"].map((field) => (
//                 <input
//                   key={field}
//                   name={field}
//                   value={enquiryForm[field]}
//                   onChange={handleEnquiryChange}
//                   placeholder={field}
//                   className="w-full border px-4 py-3 rounded-xl focus:ring-2 focus:ring-[#D0A95C]/50 outline-none"
//                   required
//                 />
//               ))}

//               <textarea
//                 name="requirements"
//                 value={enquiryForm.requirements}
//                 onChange={handleEnquiryChange}
//                 placeholder="Your requirements"
//                 className="w-full border px-4 py-3 rounded-xl focus:ring-2 focus:ring-[#D0A95C]/50 outline-none"
//               />

//               <button className="w-full bg-[#D0A95C] text-black py-3 rounded-xl font-semibold hover:scale-105 transition">
//                 Submit Enquiry
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// }

// /* TOGGLE BUTTON */
// const ToggleButton = ({ active, onClick, label }) => (
//   <button
//     onClick={onClick}
//     className={`px-7 py-2 rounded-full font-semibold transition-all ${
//       active
//         ? "bg-[#1E1E45] text-white shadow"
//         : "text-gray-600 hover:bg-gray-100"
//     }`}
//   >
//     {label}
//   </button>
// );

// /* PLAN CARD */
// function PlanCard({ plan, buttonText, onClick, highlight }) {
//   return (
//     <div
//       className={`relative bg-white rounded-3xl p-8 flex flex-col border
//       transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl
//       ${highlight ? "border-[#D0A95C] shadow-[0_20px_50px_rgba(208,169,92,0.25)]" : "border-gray-200"}`}
//     >
//       {highlight && (
//         <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D0A95C] text-black px-4 py-1 text-xs font-bold rounded-full">
//           POPULAR
//         </span>
//       )}

//       <h3 className="text-2xl font-bold text-[#1E1E45] text-center mb-4">
//         {plan.name}
//       </h3>

//       <div className="text-3xl font-bold text-center mb-6 text-[#111]">
//   {plan.priceDisplay}
// </div>


//       <div className="space-y-3 mb-8 flex-grow">
//         {plan.features.map((f, i) => (
//           <div key={i} className="flex gap-2 text-gray-700">
//             <span className="text-[#D0A95C]">✔</span>
//             {f}
//           </div>
//         ))}
//       </div>

//       <button
//         onClick={onClick}
//         className="mt-auto w-full py-3 rounded-xl font-semibold
//         bg-[#1E1E45] text-white hover:bg-[#D0A95C] hover:text-black transition"
//       >
//         {buttonText}
//       </button>
//     </div>
//   );
// }

// export default Subsplan;





















import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import Footer from "../../components/Footer";
import SubscriptionPlansConfig from "../../config/subscriptionPlansConfig";
import { useAuth } from "../../context/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function Subsplan() {
  const { globalUser } = useAuth();

  const [activeTab, setActiveTab] = useState("lawyer");
  const [selectedStudentPlan, setSelectedStudentPlan] = useState(0);
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);

  const [enquiryForm, setEnquiryForm] = useState({
    name: "",
    representingFirm: "No",
    firmName: "",
    email: "",
    contactNo: "",
    requirements: "",
  });

  const handleEnquiryChange = (e) => {
    const { name, value } = e.target;
    setEnquiryForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEnquirySubmit = async (e) => {
    e.preventDefault();

    if (!enquiryForm.name || !enquiryForm.email || !enquiryForm.contactNo) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      await addDoc(collection(db, "enterpriseEnquiries"), {
        ...enquiryForm,
        userId: globalUser?.uid || "anonymous",
        timestamp: new Date(),
      });

      await Promise.all([
        axios.post(
          "https://jurident-feedback-backend-596718606544.us-central1.run.app/sendQuery",
          {
            name: enquiryForm.name,
            email: enquiryForm.email,
            phoneNumber: enquiryForm.contactNo,
            query: enquiryForm.requirements || "Enterprise subscription enquiry",
          }
        ),
        axios.post(
          "https://jurident-feedback-backend-596718606544.us-central1.run.app/send-enquiry-thank-you",
          {
            name: enquiryForm.name,
            email: enquiryForm.email,
          }
        ),
      ]);

      toast.success("Enquiry submitted successfully");
      setShowEnquiryModal(false);
      setEnquiryForm({
        name: "",
        representingFirm: "No",
        firmName: "",
        email: "",
        contactNo: "",
        requirements: "",
      });
    } catch {
      toast.error("Failed to submit enquiry");
    }
  };

  const openAppUpgrade = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.jurident.valsco&hl=en_IN",
      "_blank"
    );
  };

  return (
    <>
      <ToastContainer />

      {/* PAGE */}
      <section className="min-h-screen bg-gradient-to-b from-[#fdfcf9] to-[#f4f6fb] pt-28 pb-32">
        <div className="max-w-7xl mx-auto px-6">

          {/* TITLE */}
          <h1 className="text-center text-4xl md:text-5xl font-extrabold text-[#1E1E45] mb-4">
            Subscription Plans
          </h1>
          <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
            Flexible, transparent pricing designed for modern legal workflows.
          </p>

          {/* TOGGLE */}
          <div className="flex justify-center mb-20">
            <div className="relative bg-white rounded-full shadow-md p-1 flex">
              <ToggleButton
                active={activeTab === "lawyer"}
                onClick={() => setActiveTab("lawyer")}
                label="Lawyers/ Law Firms"
              />

              <ToggleButton
                active={activeTab === "client"}
                onClick={() => setActiveTab("client")}
                label="Clients"
              />

              <ToggleButton
                active={activeTab === "student"}
                onClick={() => setActiveTab("student")}
                label="Students"
              />
            </div>
          </div>

          {/* LAWYERS + CLIENTS */}
          {(activeTab === "lawyer" || activeTab === "client") && (
            <div className="flex justify-center gap-10 flex-wrap">
              <PlanCard
                plan={SubscriptionPlansConfig.LAWYER_BASIC}
                buttonText="Upgrade from App"
                onClick={openAppUpgrade}
              />
              <PlanCard
                plan={SubscriptionPlansConfig.LAWYER_ENTERPRISE}
                highlight
                buttonText="Enterprise Enquiry"
                onClick={openAppUpgrade}
              />
            </div>
          )}

          {/* STUDENTS */}
          {activeTab === "student" && (
            <>
              <div className="flex justify-center gap-4 mb-12">
                {["6 Months", "Yearly"].map((label, idx) => (
                  <button
                    key={idx}
                    onClick={() => setSelectedStudentPlan(idx)}
                    className={`px-6 py-2 rounded-full font-semibold transition-all ${
                      selectedStudentPlan === idx
                        ? "bg-[#D0A95C] text-black shadow-md"
                        : "bg-white text-gray-700 border hover:bg-gray-50"
                    }`}
                  >
                    {label}
                  </button>
                ))}
              </div>

              <div className="flex justify-center">
                <PlanCard
                  plan={
                    selectedStudentPlan === 0
                      ? SubscriptionPlansConfig.LAW_STUDENT_SIX_MONTHS
                      : SubscriptionPlansConfig.LAW_STUDENT_ONE_YEAR
                  }
                  buttonText="Upgrade from App"
                  onClick={openAppUpgrade}
                />
              </div>
            </>
          )}

          {/* NOTE */}
          <div className="mt-24 max-w-4xl mx-auto flex gap-2 text-gray-600 text-sm">
            <span className="text-[#D0A95C] font-bold">*</span>
            Pricing is flexible and may vary based on customization and selected features.
          </div>
        </div>
      </section>

      {/* MODAL */}
      {showEnquiryModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md">
            <h2 className="text-xl font-bold text-[#1E1E45] mb-6 text-center">
              Enterprise Enquiry
            </h2>

            <form onSubmit={handleEnquirySubmit} className="space-y-4">
              {["name", "email", "contactNo"].map((field) => (
                <input
                  key={field}
                  name={field}
                  value={enquiryForm[field]}
                  onChange={handleEnquiryChange}
                  placeholder={field}
                  className="w-full border px-4 py-3 rounded-xl focus:ring-2 focus:ring-[#D0A95C]/50 outline-none"
                  required
                />
              ))}

              <textarea
                name="requirements"
                value={enquiryForm.requirements}
                onChange={handleEnquiryChange}
                placeholder="Your requirements"
                className="w-full border px-4 py-3 rounded-xl focus:ring-2 focus:ring-[#D0A95C]/50 outline-none"
              />

              <button className="w-full bg-[#D0A95C] text-black py-3 rounded-xl font-semibold hover:scale-105 transition">
                Submit Enquiry
              </button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

/* TOGGLE BUTTON */
const ToggleButton = ({ active, onClick, label }) => (
  <button
    onClick={onClick}
    className={`px-7 py-2 rounded-full font-semibold transition-all ${
      active
        ? "bg-[#1E1E45] text-white shadow"
        : "text-gray-600 hover:bg-gray-100"
    }`}
  >
    {label}
  </button>
);

/* PLAN CARD */
function PlanCard({ plan, buttonText, onClick, highlight }) {
  return (
    <div
      className={`relative bg-white rounded-3xl p-8 flex flex-col border
      transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl
      ${highlight ? "border-[#D0A95C] shadow-[0_20px_50px_rgba(208,169,92,0.25)]" : "border-gray-200"}`}
    >
      {highlight && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D0A95C] text-black px-4 py-1 text-xs font-bold rounded-full">
          POPULAR
        </span>
      )}

      <h3 className="text-2xl font-bold text-[#1E1E45] text-center mb-4">
        {plan.name}
      </h3>

      <div className="text-3xl font-bold text-center mb-6 text-[#111]">
        {plan.priceDisplay}
      </div>

      <div className="space-y-3 mb-8 flex-grow">
        {plan.features.map((f, i) => (
          <div key={i} className="flex gap-2 text-gray-700">
            <span className="text-[#D0A95C]">✔</span>
            {f}
          </div>
        ))}
      </div>

      <button
        onClick={onClick}
        className="mt-auto w-full py-3 rounded-xl font-semibold
        bg-[#1E1E45] text-white hover:bg-[#D0A95C] hover:text-black transition"
      >
        {buttonText}
      </button>
    </div>
  );
}

export default Subsplan;